import { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import Loader from "../components/misc/Loader";

export default function RedirectRole() {
  const { user, loading, redirectByRole } = useContext(AuthContext);

  useEffect(() => {
    if (!loading && user) {
      redirectByRole();
    }
  }, [loading, user]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader />
    </div>
  );
}
